import React, { useEffect, useState } from "react";
import "./Catalog.css";
import {
  getTicketsCvaURL,
} from "../../../utils/constants";
import Loading from "../../../../../../application/commons/loading/loading";
import { appConfig } from "../../../../../../utils/app.config";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../utils/redux-store/appStore";

interface CatalogProps {
  mode: string;
}

const Catalog: React.FC<CatalogProps> = (mode: any) => {
  const [activeButton, setActiveButton] = useState("Incident");
  const [topIncidents, setTopIncidents] = useState<any>([]);
  const [loadingIncidents, setLoadingIncidents] = useState(true);
  const redirectUrl: string = useSelector(
    (state: any) => state.headers.redirectUrl
  );
  const userProfile = useSelector((store: any) => store.login.loginDetails);
  const error_msg = "Your servicenow account is not available. Please contact admin to create one";
  const accountExist: boolean = useSelector((state: RootState) => state.serviceNowDetails.accountExist);
  const topCatalogList = useSelector((state: RootState) => state.serviceNowDetails.catalogs);

  useEffect(() => {
    if (accountExist) {
      getTicketsCva();
    } else {
      setLoadingIncidents(false);
    }
  }, []);

  const getTicketsCva = async () => {
    try {
      setLoadingIncidents(true);
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      };
      const result: any = await (await fetch(`${getTicketsCvaURL}?email=${userProfile.email}&limit=10`, options)).json();
      if (result) {
        setTopIncidents([...result.activeTickets]);
        setLoadingIncidents(false);
      }
    } catch (err) {
      setTopIncidents([]);
      setLoadingIncidents(false);
      console.log('ERROR :::', err);
    }
  }

  const handleIncidentClick = (incident: any) => {
    console.log("Incident Clicked", incident["number"]);
    console.log(incident);
  };

  return (
    <div className="catalog-main-container">
      <div className="catalog-buttons-container">
        <div className="catalog-incident-container">
          <button
            className={`catalog-button-${mode.mode} ${activeButton === "Incident" ? "active" : ""
              }`}
            onClick={() => setActiveButton("Incident")}
          >
            Incident
          </button>
        </div>
        <div className="catalog-raise-catalog-container">
          <button
            className={`catalog-button-${mode.mode} ${activeButton === "RaiseCatalog" ? "active" : ""
              }`}
            onClick={() => setActiveButton("RaiseCatalog")}
          >
            Raise Catalog
          </button>
        </div>
      </div>
      {/* Conditional rendering of content based on the active button */}
      <div className="catalog-main-content-display">
        {activeButton === "Incident" &&
          (loadingIncidents ? (
            <Loading message="Loading Incidents..." />
          ) : (
            (accountExist ?
              <>
                {topIncidents.length > 0 ?
                  <>
                    <div className="topIncident-title">
                      Top {topIncidents.length} Incident List
                    </div>
                    <ul className="catalog-main-list">
                      {topIncidents.map((incident: any, index: number) => (
                        <Link key={index}
                          to={`${redirectUrl}/desktop/raise-ticket`}
                          state={{ ticketData: incident, type: "Incident" }}
                          style={{ textDecoration: 'auto', color: 'black' }}
                        >
                          <li
                            className="topIncident-incident"
                            key={index}
                            onClick={() => handleIncidentClick(incident)}
                          >
                            <img
                              className="incidentIcon"
                              src={appConfig.imagesUrl + "/desktop/incident.png"}
                            />{" "}
                            {incident["short_description"]}
                          </li>
                        </Link>
                      ))}
                    </ul>
                  </>
                  :
                  <h6 style={{ textAlign: "center", padding: "30px" }}>No Incidents Available</h6>
                }
              </> :
              <h6 style={{ textAlign: "center", padding: "30px" }}>{error_msg}</h6>
            )
          )
          )
        }

        {activeButton === "RaiseCatalog" &&
          (accountExist ?
            <>
              {
                topCatalogList.length > 0 ?
                  <>
                    <div className="topCatalog-title">
                      Top {topCatalogList.length} Catalog List
                    </div>
                    <ul className="catalog-main-list">
                      {topCatalogList.map((catalog, index) => (
                        <Link key={index}
                          to={`${redirectUrl}/desktop/raise-catalog`}
                          state={{ catalogData: catalog }}
                          style={{ textDecoration: 'auto', color: 'black' }}

                        >
                          <li
                            className="topCatalog-catalog"
                            key={index}
                            onClick={() => handleIncidentClick(catalog)}
                          >
                            <img
                              className="catalogIcon"
                              src={appConfig.imagesUrl + "/desktop/Catalog.png"}
                            />{" "}
                            {catalog["title"]}
                          </li>
                        </Link>
                      ))}
                    </ul>
                  </>
                  :
                  <h6 style={{ textAlign: "center", padding: "30px" }}>No Raise Catalogs Available</h6>
              }
            </> :
            <h6 style={{ textAlign: "center", padding: "30px" }}>{error_msg}</h6>
          )
        }
      </div>
    </div>
  );
};

export default Catalog;
